import { useMutation, useQueryClient } from '@tanstack/react-query';

import rateGroupRuleService, { CreateRateGroupRuleBody } from '~/services/cruises/RateGroupRuleService';

import { rateGroupQueryKeys } from './rateGroupQueryKeys';

export function useCreateRateGroupRule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ rateGroupId, body }: { rateGroupId: string; body: CreateRateGroupRuleBody }) => {
      return await rateGroupRuleService.create(rateGroupId, body);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: rateGroupQueryKeys.all });
    },
  });
}
